<template>
  <div class="content-builder">
    <div class="form-group">
      <QuillEditor :toolbar="toolbarOpts" :modules="editorModules" theme="snow" :contentType="'html'" v-model:content="content.body"/>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import layoutMixin from '../../mixins/layout'
  import { EDITOR_CONFIG_BUTTONS_FULL } from '../../../common/constants'
  import { QuillEditor } from '@vueup/vue-quill'
  import '@vueup/vue-quill/dist/vue-quill.snow.css'

  export default {
    components: {
      QuillEditor
    },
    mixins: [layoutMixin],
    data() {
      const content = _.cloneDeep(this.source)
      return {
        toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL,
        content: content
      }
    },
    methods: {
      setContent() {
      },
      getValue() {
        return this.content
      }
    }
  }
</script>
